import { render, staticRenderFns } from "./RobDetail.vue?vue&type=template&id=c312d0a6&scoped=true"
import script from "./RobDetail.vue?vue&type=script&lang=js"
export * from "./RobDetail.vue?vue&type=script&lang=js"
import style0 from "./RobDetail.vue?vue&type=style&index=0&id=c312d0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c312d0a6",
  null
  
)

export default component.exports